import axios from "axios";
import {
  ADD_POST,
  GET_POSTS,
  LOADING_POSTS,
  LIKE_POST_SUCCESS,
  UNLIKE_POST_SUCCESS,
  POST_ERROR,
  DELETE_POST_SUCCESS,
  UPDATE_POST_ERROR,
  UPDATE_POST_SUCCESS,
  DELETE_POST_ERROR,
} from "../constants";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export const addPost = (postData) => (dispatch) => {
  axios
    .post(`${SERVER_URL}/api/posts/add`, postData)
    .then((res) =>
      dispatch({
        type: ADD_POST,
        payload: res.data,
      })
    )
    .catch((err) => console.log(err));
};

export const getPosts = () => (dispatch) => {
  dispatch(loadPosts);
  axios
    .get(`${SERVER_URL}/api/posts`)
    .then((res) =>
      dispatch({
        type: GET_POSTS,
        payload: res.data,
      })
    )
    .catch((err) => console.log(err));
};

export const getPostsByFollowingUsers = () => (dispatch) => {
  axios
    .get(`${SERVER_URL}/api/posts/following`)
    .then((res) =>
      dispatch({
        type: GET_POSTS,
        payload: res.data,
      })
    )
    .catch((err) => console.log(err));
};

export const loadPosts = () => {
  return {
    type: LOADING_POSTS,
  };
};

export const likePost = (postId) => async (dispatch) => {
  try {
    const res = await axios.post(`${SERVER_URL}/api/posts/like/${postId}`);
    dispatch({
      type: LIKE_POST_SUCCESS,
      payload: { postId, likes: res.data.likes },
    });
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const unlikePost = (postId) => async (dispatch) => {
  try {
    const res = await axios.post(`${SERVER_URL}/api/posts/unlike/${postId}`);
    dispatch({
      type: UNLIKE_POST_SUCCESS,
      payload: { postId, likes: res.data.likes },
    });
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const deletePost = (postId) => (dispatch) => {
  axios
    .delete(`${SERVER_URL}/api/posts/delete/${postId}`)
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: DELETE_POST_SUCCESS,
          payload: postId,
        });
      } else {
        dispatch({
          type: DELETE_POST_ERROR,
          payload: res.data.error,
        });
      }
    })
    .catch((err) => {
      console.log(err)
      dispatch({
        type: DELETE_POST_ERROR,
        payload: err.response?.data?.error || "An error occurred",
      });
    });
};

export const updatePost = (postId, text) => async dispatch => {
  try {
      const response = await axios.put(`${SERVER_URL}/api/posts/update/${postId}`, {
          text
      });

      dispatch({ type: UPDATE_POST_SUCCESS, payload: response.data });
      dispatch(getPosts());

  } catch (error) {
      const errorMessage = error.response && error.response.data.error ? error.response.data.error : error.message;
      dispatch({ type: UPDATE_POST_ERROR, payload: errorMessage });
  }
};
